var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCollectionPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 207,
    viewBox: "0 0 254 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.175 205C149.075 202.6 149.075 198.7 153.175 196.3L160.275 192.2C164.375 189.8 171.175 189.8 175.275 192.2C179.375 194.6 179.375 198.5 175.275 200.9L168.175 205C164.075 207.4 157.275 207.4 153.175 205ZM171.275 194.5C169.375 193.4 166.275 193.4 164.275 194.5L157.175 198.6C155.275 199.7 155.275 201.5 157.175 202.6C159.075 203.7 162.175 203.7 164.175 202.6L171.275 198.5C173.175 197.4 173.175 195.6 171.275 194.5Z",
    fill: "#F1ECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.075 200.6C144.975 198.2 144.975 194.3 149.075 191.9L156.175 187.8C160.275 185.4 167.075 185.4 171.175 187.8C175.275 190.2 175.275 194.1 171.175 196.5L164.075 200.6C159.975 203 153.275 203 149.075 200.6ZM167.175 190.1C165.275 189 162.175 189 160.175 190.1L153.075 194.2C151.175 195.3 151.175 197.1 153.075 198.2C154.975 199.3 158.075 199.3 160.075 198.2L167.175 194.1C169.175 193 169.175 191.2 167.175 190.1Z",
    fill: "#F7F7FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.175 190.1C165.275 189 162.175 189 160.175 190.1L153.075 194.2C151.175 195.3 151.175 197.1 153.075 198.2C153.175 198.3 153.275 198.3 153.375 198.4L160.175 194.5C161.975 193.5 164.875 193.4 166.775 194.3L167.075 194.1C169.175 193 169.175 191.2 167.175 190.1Z",
    fill: "#59595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.275 196.5L164.175 200.6C160.075 203 153.275 203 149.175 200.6C147.075 199.4 146.075 197.9 146.075 196.3V200.6C146.075 202.2 147.075 203.8 149.175 205C153.275 207.4 160.075 207.4 164.175 205L171.275 200.9C173.375 199.7 174.375 198.1 174.375 196.6V192.2C174.375 193.7 173.275 195.3 171.275 196.5Z",
    fill: "#59595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1751 189C9.0751 186.6 9.0751 182.7 13.1751 180.3L20.2751 176.2C24.3751 173.8 31.1751 173.8 35.2751 176.2C39.3751 178.6 39.3751 182.5 35.2751 184.9L28.1751 189C24.0751 191.4 17.2751 191.4 13.1751 189ZM31.2751 178.5C29.3751 177.4 26.2751 177.4 24.2751 178.5L17.1751 182.6C15.2751 183.7 15.2751 185.5 17.1751 186.6C19.0751 187.7 22.1751 187.7 24.1751 186.6L31.2751 182.5C33.1751 181.4 33.1751 179.6 31.2751 178.5Z",
    fill: "#F1ECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.075 184.6C4.975 182.2 4.975 178.3 9.075 175.9L16.175 171.8C20.275 169.4 27.075 169.4 31.175 171.8C35.275 174.2 35.275 178.1 31.175 180.5L24.075 184.6C19.975 187 13.275 187 9.075 184.6ZM27.175 174.1C25.275 173 22.175 173 20.175 174.1L13.075 178.2C11.175 179.3 11.175 181.1 13.075 182.2C14.975 183.3 18.075 183.3 20.075 182.2L27.175 178.1C29.175 177 29.175 175.2 27.175 174.1Z",
    fill: "#F7F7FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1749 174.1C25.2749 173 22.1749 173 20.1749 174.1L13.0749 178.2C11.1749 179.3 11.1749 181.1 13.0749 182.2C13.1749 182.3 13.2749 182.3 13.3749 182.4L20.1749 178.5C21.9749 177.5 24.8749 177.4 26.7749 178.3L27.0749 178.1C29.1749 177 29.1749 175.2 27.1749 174.1Z",
    fill: "#59595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.275 180.5L24.175 184.6C20.075 187 13.2749 187 9.17495 184.6C7.07495 183.4 6.07495 181.9 6.07495 180.3V184.6C6.07495 186.2 7.07495 187.8 9.17495 189C13.2749 191.4 20.075 191.4 24.175 189L31.275 184.9C33.375 183.7 34.375 182.1 34.375 180.6V176.2C34.375 177.7 33.275 179.3 31.275 180.5Z",
    fill: "#59595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 135H26.3L30.4 137.4L9.09998 149.7H16.6L38 137.4L33.9 135Z",
    fill: "url(#paint0_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09998 145.3L5 143L22.3 133L19.4 131.3L23.4 129L30.4 133L9.09998 145.3Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09998 149.7L5 147.4V143L9.09998 145.3V149.7Z",
    fill: "#F1ECEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3999 134.7V131.3L22.2999 133L19.3999 134.7Z",
    fill: "#F1ECEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6003 137.3L9.30029 149.6V145.2L30.6003 132.9V137.3Z",
    fill: "#59595B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1422 46.0505H22.183L44.3659 58.8268L22.183 71.7435H57.1422L79.3252 58.8268L57.1422 46.0505Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.183 71.7435L44.3659 58.8268V33.2743L22.183 46.0505V71.7435Z",
    fill: "#292929"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1829 71.7435L0 58.8268V33.2743L22.1829 46.0505V71.7435Z",
    fill: "#CACACB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1829 46.0507L0 33.2744L22.1829 20.4982L44.3659 33.2744L22.1829 46.0507Z",
    fill: "#C0162E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.274 138.882H173.917L186.833 146.323L173.917 153.764H194.274L207.191 146.323L194.274 138.882Z",
    fill: "url(#paint3_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.917 153.764L186.833 146.323V131.441L173.917 138.882V153.764Z",
    fill: "#292929"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.917 153.764L161 146.323V131.441L173.917 138.882V153.764Z",
    fill: "#313131"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.917 138.882L161 131.441L173.917 124L186.833 131.441L173.917 138.882Z",
    fill: "#CACACB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 68.0932H226.884L249.629 54.8958C251.173 53.913 252.717 53.913 253.7 54.4746L218.601 34.2572H194.171V68.0932Z",
    fill: "url(#paint4_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 33.9764L164.688 16.9882L194.171 0L223.655 16.9882L194.171 33.9764Z",
    fill: "#F1ECEC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 68.0932L164.688 50.9646V16.9882L194.171 33.9764V68.0932Z",
    fill: "#59595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 68.0932L223.655 50.9646V16.9882L194.171 33.9764V68.0932Z",
    fill: "#CACACB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 5.61595L191.784 4.21196L194.171 2.94836L196.558 4.21196L194.171 5.61595Z",
    fill: "#59595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.647 8.84496L197.26 7.44097L199.647 6.03699L202.034 7.44097L199.647 8.84496Z",
    fill: "#59595B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.122 11.9338L202.876 10.6702L205.122 9.26624L207.509 10.6702L205.122 11.9338Z",
    fill: "#59595B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.738 15.163L208.352 13.7591L210.738 12.4955L212.985 13.7591L210.738 15.163Z",
    fill: "#59595B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M216.214 18.3922L213.827 16.9882L216.214 15.5842L218.46 16.9882L216.214 18.3922Z",
    fill: "#59595B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188.696 8.84496L186.309 7.44097L188.696 6.03699L191.083 7.44097L188.696 8.84496Z",
    fill: "#59595B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 11.9338L191.784 10.6702L194.171 9.26624L196.558 10.6702L194.171 11.9338Z",
    fill: "#59595B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M199.647 15.163L197.26 13.7591L199.647 12.4955L202.034 13.7591L199.647 15.163Z",
    fill: "#59595B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.122 18.3922L202.876 16.9882L205.122 15.5842L207.509 16.9882L205.122 18.3922Z",
    fill: "#59595B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M210.738 21.4809L208.352 20.0769L210.738 18.8134L212.985 20.0769L210.738 21.4809Z",
    fill: "#59595B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.22 11.9338L180.833 10.6702L183.22 9.26624L185.607 10.6702L183.22 11.9338Z",
    fill: "#59595B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M188.696 15.163L186.309 13.7591L188.696 12.4955L191.083 13.7591L188.696 15.163Z",
    fill: "#59595B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 18.3922L191.784 16.9882L194.171 15.5842L196.558 16.9882L194.171 18.3922Z",
    fill: "#59595B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.647 21.4809L197.26 20.0769L199.647 18.8134L202.034 20.0769L199.647 21.4809Z",
    fill: "#59595B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M205.122 24.7101L202.876 23.3061L205.122 21.9021L207.509 23.3061L205.122 24.7101Z",
    fill: "#59595B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M177.745 15.163L175.358 13.7591L177.745 12.4955L180.131 13.7591L177.745 15.163Z",
    fill: "#59595B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.22 18.3922L180.833 16.9882L183.22 15.5842L185.607 16.9882L183.22 18.3922Z",
    fill: "#59595B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M188.696 21.4809L186.309 20.0769L188.696 18.8134L191.083 20.0769L188.696 21.4809Z",
    fill: "#59595B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 24.7101L191.784 23.3061L194.171 21.9021L196.558 23.3061L194.171 24.7101Z",
    fill: "#59595B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M199.647 27.7989L197.26 26.5353L199.647 25.1313L202.034 26.5353L199.647 27.7989Z",
    fill: "#59595B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.269 18.3922L169.883 16.9882L172.269 15.5842L174.656 16.9882L172.269 18.3922Z",
    fill: "#59595B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.745 21.4809L175.358 20.0769L177.745 18.8134L180.131 20.0769L177.745 21.4809Z",
    fill: "#59595B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M183.22 24.7101L180.833 23.3061L183.22 21.9021L185.607 23.3061L183.22 24.7101Z",
    fill: "#59595B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M188.696 27.7989L186.309 26.5353L188.696 25.1313L191.083 26.5353L188.696 27.7989Z",
    fill: "#59595B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M194.171 31.0281L191.784 29.6241L194.171 28.2201L196.558 29.6241L194.171 31.0281Z",
    fill: "#59595B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 25.5524L167.355 24.1484V21.4808L169.602 22.7444V25.5524Z",
    fill: "#59595B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M175.077 28.6412L172.831 27.3777V24.5697L175.077 25.9737V28.6412Z",
    fill: "#59595B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M180.693 31.8704L178.306 30.4664V27.7988L180.693 29.2028V31.8704Z",
    fill: "#59595B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 34.9592L183.782 33.6957V30.8877L186.168 32.2917V34.9592Z",
    fill: "#59595B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M191.644 38.1883L189.258 36.7843V34.1167L191.644 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 31.8704L167.355 30.4664V27.7988L169.602 29.2028V31.8704Z",
    fill: "#59595B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M175.077 34.9592L172.831 33.6957V30.8877L175.077 32.2917V34.9592Z",
    fill: "#59595B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M180.693 38.1883L178.306 36.7843V34.1167L180.693 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 41.4175L183.782 40.0135V37.3459L186.168 38.6095V41.4175Z",
    fill: "#59595B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M191.644 44.5063L189.258 43.2427V40.4347L191.644 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 38.1883L167.355 36.7843V34.1167L169.602 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M175.077 41.4175L172.831 40.0135V37.3459L175.077 38.6095V41.4175Z",
    fill: "#59595B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.693 44.5063L178.306 43.2427V40.4347L180.693 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 47.7354L183.782 46.3314V43.6638L186.168 44.9274V47.7354Z",
    fill: "#59595B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M191.644 50.8241L189.258 49.5605V46.7526L191.644 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 44.5063L167.355 43.2427V40.4347L169.602 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M175.077 47.7354L172.831 46.3314V43.6638L175.077 44.9274V47.7354Z",
    fill: "#59595B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M180.693 50.8241L178.306 49.5605V46.7526L180.693 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 54.0534L183.782 52.6494V49.9818L186.168 51.3858V54.0534Z",
    fill: "#59595B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M191.644 57.2825L189.258 55.8785V53.0706L191.644 54.4745V57.2825Z",
    fill: "#59595B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 50.8241L167.355 49.5605V46.7526L169.602 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M175.077 54.0534L172.831 52.6494V49.9818L175.077 51.3858V54.0534Z",
    fill: "#59595B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M180.693 57.2825L178.306 55.8785V53.0706L180.693 54.4745V57.2825Z",
    fill: "#59595B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 60.3713L183.782 58.9673V56.2997L186.168 57.7037V60.3713Z",
    fill: "#59595B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M191.644 63.6005L189.258 62.1965V59.5289L191.644 60.7925V63.6005Z",
    fill: "#59595B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M218.741 25.5524L221.128 24.1484V21.4808L218.741 22.7444V25.5524Z",
    fill: "#59595B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 28.6412L215.652 27.3777V24.5697L213.265 25.9737V28.6412Z",
    fill: "#59595B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79 31.8704L210.177 30.4664V27.7988L207.79 29.2028V31.8704Z",
    fill: "#59595B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M202.314 34.9592L204.561 33.6957V30.8877L202.314 32.2917V34.9592Z",
    fill: "#59595B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 38.1883L199.085 36.7843V34.1167L196.839 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M218.741 31.8704L221.128 30.4664V27.7988L218.741 29.2028V31.8704Z",
    fill: "#59595B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 34.9592L215.652 33.6957V30.8877L213.265 32.2917V34.9592Z",
    fill: "#59595B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79 38.1883L210.177 36.7843V34.1167L207.79 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M202.314 41.4175L204.561 40.0135V37.3459L202.314 38.6095V41.4175Z",
    fill: "#59595B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 44.5063L199.085 43.2427V40.4347L196.839 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M218.741 38.1883L221.128 36.7843V34.1167L218.741 35.5207V38.1883Z",
    fill: "#59595B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 41.4175L215.652 40.0135V37.3459L213.265 38.6095V41.4175Z",
    fill: "#59595B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79 44.5063L210.177 43.2427V40.4347L207.79 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M202.314 47.7354L204.561 46.3314V43.6638L202.314 44.9274V47.7354Z",
    fill: "#59595B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 50.8241L199.085 49.5605V46.7526L196.839 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M218.741 44.5063L221.128 43.2427V40.4347L218.741 41.8387V44.5063Z",
    fill: "#59595B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 47.7354L215.652 46.3314V43.6638L213.265 44.9274V47.7354Z",
    fill: "#59595B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79 50.8241L210.177 49.5605V46.7526L207.79 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M202.314 54.0534L204.561 52.6494V49.9818L202.314 51.3858V54.0534Z",
    fill: "#59595B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 57.2825L199.085 55.8785V53.0706L196.839 54.4745V57.2825Z",
    fill: "#59595B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M218.741 50.8241L221.128 49.5605V46.7526L218.741 48.1565V50.8241Z",
    fill: "#59595B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 54.0534L215.652 52.6494V49.9818L213.265 51.3858V54.0534Z",
    fill: "#59595B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79 57.2825L210.177 55.8785V53.0706L207.79 54.4745V57.2825Z",
    fill: "#59595B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M202.314 60.3713L204.561 58.9673V56.2997L202.314 57.7037V60.3713Z",
    fill: "#59595B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 63.6005L199.085 62.1965V59.5289L196.839 60.7925V63.6005Z",
    fill: "#59595B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M206.526 63.3197H186.168L199.085 70.7608L186.168 78.2019H206.526L219.443 70.7608L206.526 63.3197Z",
    fill: "url(#paint5_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 78.202L199.085 70.7609V55.8787L186.168 63.3198V78.202Z",
    fill: "#292929"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 78.202L173.251 70.7609V55.8787L186.168 63.3198V78.202Z",
    fill: "#313131"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M186.168 63.3197L173.251 55.8786L186.168 48.4375L199.085 55.8786L186.168 63.3197Z",
    fill: "#CACACB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M115.267 51.5264C109.511 48.1568 109.511 42.6813 115.267 39.3117L125.235 33.5554C130.992 30.1858 140.539 30.1858 146.295 33.5554C152.051 36.9249 152.051 42.4005 146.295 45.77L136.327 51.5264C130.57 54.8959 121.164 54.8959 115.267 51.5264ZM140.679 36.9249C138.012 35.3805 133.659 35.3805 130.851 36.9249L120.883 42.6813C118.215 44.2257 118.215 46.7528 120.883 48.2972C123.55 49.8416 127.903 49.8416 130.711 48.2972L140.679 42.5409C143.487 40.9965 143.487 38.4693 140.679 36.9249Z",
    fill: "url(#paint6_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M109.65 45.4891C103.894 42.1196 103.894 36.644 109.65 33.2745L119.619 27.5181C125.375 24.1486 134.922 24.1486 140.678 27.5181C146.435 30.8877 146.435 36.3632 140.678 39.7328L130.71 45.4891C124.954 48.8587 115.407 48.8587 109.65 45.4891ZM135.062 30.7473C132.395 29.2029 128.043 29.2029 125.235 30.7473L115.266 36.5037C112.599 38.048 112.599 40.5752 115.266 42.1196C117.934 43.664 122.286 43.664 125.094 42.1196L135.062 36.3632C137.73 34.8189 137.73 32.2917 135.062 30.7473Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M135.064 30.7474C132.396 29.203 128.044 29.203 125.236 30.7474L115.267 36.5037C112.6 38.0481 112.6 40.5753 115.267 42.1197C115.408 42.2601 115.548 42.2601 115.689 42.4005L125.236 36.9249C127.763 35.5209 131.834 35.3805 134.502 36.6441L134.923 36.3633C137.731 34.819 137.731 32.2918 135.064 30.7474Z",
    fill: "#59595B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M140.679 39.7327L130.711 45.489C124.955 48.8586 115.407 48.8586 109.651 45.489C106.703 43.8042 105.299 41.6983 105.299 39.4519V45.489C105.299 47.7354 106.703 49.9818 109.651 51.6665C115.407 55.0361 124.955 55.0361 130.711 51.6665L140.679 45.9102C143.628 44.2254 145.032 41.9791 145.032 39.8731V33.6956C145.032 35.8015 143.628 38.0479 140.679 39.7327Z",
    fill: "#59595B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7 149.488C69.1 148.388 66.7 150.288 66 152.288C66 153.188 66.6 154.588 66.6 154.588C66.6 154.588 69.2 160.388 70.1 161.388C71 162.388 74.6 163.788 76.3 162.288C77.6 160.688 75.1 159.688 74.6 158.088C74 155.988 74.3 154.288 73.7 152.788C73.3 151.488 70.7 149.488 70.7 149.488Z",
    fill: "#C0162E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 151.888C66.2 152.788 66.8 154.188 66.8 154.188C66.8 154.188 69.4 159.988 70.3 160.988C71.2 161.988 74.8 163.388 76.6 161.888C76.7 161.788 76.7 161.688 76.8 161.588C76.8 161.788 76.7 161.988 76.5 162.188C74.8 163.688 71.1 162.288 70.3 161.288C69.4 160.288 66.8 154.488 66.8 154.488C66.8 154.488 66.2 152.988 66.2 152.188C66.1 152.088 66.1 151.988 66.2 151.888Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150.788C74.2 150.288 71.1001 149.088 71.1001 149.088C71.1001 149.088 70.8 149.488 70.4 149.588H70.3001C69.5001 149.588 68.1 150.288 69 151.888C70.7 154.988 74.6 154.788 74.2 153.388C73.8 152.588 74.6 151.388 75 150.788Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0179 154.327C74.1179 153.827 74.3179 152.827 73.0179 152.627C71.7179 152.427 70.218 153.027 70.418 153.827C70.618 155.427 73.8179 154.827 74.0179 154.327Z",
    fill: "#59595B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3 149.188C70.8 147.188 81.6 134.088 86.8 131.488C85.1 124.288 80.6 114.888 82 107.188H92.9C92.9 107.188 99.4 130.088 95.2 135.588C92.1 139.688 78.2 150.288 73 153.588C71.3 153.588 68.7 150.688 69.3 149.188Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5999 168.188C76.6999 168.488 76.1999 171.488 77.0999 173.388C77.6999 174.088 79.1999 174.688 79.1999 174.688C79.1999 174.688 85.0999 177.088 86.3999 177.188C87.6999 177.288 90.6999 176.788 90.8999 174.488C90.6999 173.088 89.4999 172.688 88.0999 171.888C86.1999 170.788 84.5999 169.188 83.0999 168.388C81.8999 167.888 78.5999 168.188 78.5999 168.188Z",
    fill: "#C0162E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3999 176.588C84.9999 176.488 78.8999 173.988 78.8999 173.988C78.8999 173.988 77.4999 173.388 76.8999 172.788C76.9999 172.988 76.9999 173.288 77.0999 173.488C77.6999 174.188 79.1999 174.788 79.1999 174.788C79.1999 174.788 85.0999 177.188 86.3999 177.288C87.6999 177.388 90.6999 176.888 90.8999 174.588V174.488C90.2999 176.288 87.5999 176.688 86.3999 176.588Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5998 166.188C81.6998 166.288 78.5998 167.688 78.5998 167.688C78.5998 167.688 78.6998 168.088 78.3998 168.588C78.3998 168.588 78.3998 168.688 78.2998 168.688C77.6998 169.188 77.0998 170.188 78.8998 170.688C82.1998 171.688 85.0998 169.488 83.7998 168.788C82.8998 168.288 82.6998 166.888 82.5998 166.188Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3998 169.288C84.1998 168.988 83.5998 168.088 82.5998 168.788C81.4998 169.588 81.2998 170.488 81.3998 171.188C81.4998 171.988 83.6998 171.388 83.7998 171.288C83.7998 171.188 84.3998 169.288 84.3998 169.288Z",
    fill: "#59595B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2999 106.788C83.2999 116.988 83.3998 128.488 83.3998 137.388C83.3998 147.588 84.1999 160.288 84.0999 168.888C82.4999 170.888 78.2999 170.388 77.3999 168.888C76.2999 161.088 73.8998 149.288 74.4998 140.788C71.8998 129.588 68.6998 116.288 69.6998 107.488C72.1998 108.288 80.8999 105.988 83.2999 106.788Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2 65.4879C94.6 68.1879 96.6 76.2879 96.9 81.8879C97.1 85.5879 97.5 99.0879 92.3 95.9879C87.1 92.7879 86.2 65.4879 86.2 65.4879Z",
    fill: "#59595B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2 71.3879C72.4 68.6879 77.7 64.8879 81.2 64.5879C87.1 64.1879 91.8 69.0879 93 73.1879C94.1 77.0879 93.5 106.188 94.8 111.388C94.2 114.188 89.1 115.688 87.2 116.088C78.8 117.888 69.3 117.588 68.6 112.288C67.4 102.388 67.1 74.4879 70.2 71.3879Z",
    fill: "url(#paint7_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5001 56.7878C80.3001 54.8878 86.9001 58.7878 86.7001 61.2878C86.5001 63.3878 85.9001 65.1878 88.0001 66.4878C88.7001 67.0878 91.2001 71.0878 87.4001 71.0878C82.0001 71.1878 80.5001 69.6878 76.6001 66.2878C78.9001 64.9878 81.2001 62.9878 80.5001 56.7878Z",
    fill: "#F6D3AF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9001 55.5878L81.6002 51.7878H93.3002V58.8878C93.3002 62.7878 90.7001 65.9878 87.4001 65.9878C84.3001 65.9878 81.3001 63.3878 81.2001 59.6878L79.8002 59.1878L78.9001 55.5878Z",
    fill: "#F6D3AF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 67.8877C84.4001 67.8877 80.9001 63.3877 81.2001 59.6877C81.3001 63.1877 84.3001 65.6877 87.2001 65.9877C87.4001 66.1877 87.6001 66.2877 87.9001 66.4877C88.0001 66.4877 88.0001 66.5877 88.1001 66.6877C88.1001 67.1877 87.7001 67.8877 87.2001 67.8877Z",
    fill: "#EBC5A3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7001 48.6878C93.8001 48.4878 93.9001 47.5878 89.5001 46.0878C87.0001 44.8878 83.4002 44.4878 81.1002 45.8878C78.0002 47.7878 77.0002 50.6878 77.6002 54.2878C78.2002 57.8878 80.5001 61.2878 80.5001 61.2878C80.8001 61.6878 80.9002 59.9878 80.6002 58.7878C80.5002 58.6878 80.3001 58.2878 80.2001 57.7878C79.4001 54.1878 81.6001 54.6878 81.9001 54.9878C82.6001 55.2878 81.3002 58.2878 83.3002 57.9878C84.3002 57.8878 84.1002 55.0878 84.1002 54.1878C84.2002 54.1878 84.4001 54.2878 84.5001 54.2878C86.2001 55.1878 91.8001 55.8878 88.7001 53.8878C90.9001 53.8878 93.9001 54.8878 94.9001 53.4878C96.0001 51.7878 94.1001 49.9878 92.7001 48.6878Z",
    fill: "#292929"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M124.711 114.203L109.799 122.785C109.007 123.272 108.216 123.272 107.729 122.968C107.181 122.664 106.877 121.994 106.877 121.02V103.855C106.877 102.882 107.181 101.847 107.729 100.934C108.277 100.021 109.007 99.1687 109.799 98.7426L124.711 90.1603C125.502 89.6733 126.294 89.6733 126.781 89.9777C127.328 90.282 127.633 90.9515 127.633 91.9254V109.09C127.633 110.064 127.328 111.099 126.781 112.012C126.294 112.864 125.563 113.716 124.711 114.203Z",
    fill: "#313131"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M106.878 121.081V103.916C106.878 102.943 107.182 101.908 107.73 100.995C108.277 100.082 109.008 99.2296 109.799 98.8035L124.712 90.2212C125.503 89.7343 126.294 89.7343 126.781 90.0386L107.304 78.7781C106.756 78.4738 106.025 78.5346 105.234 78.9607L90.3215 87.543C89.5303 88.03 88.739 88.8212 88.252 89.7343C87.7042 90.6473 87.3999 91.682 87.3999 92.6559V109.881C87.3999 110.855 87.7042 111.464 88.252 111.829L107.73 123.09C107.243 122.664 106.878 121.994 106.878 121.081Z",
    fill: "#292929"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M104.686 99.1688C105.234 98.2558 105.964 97.4036 106.756 96.9776L121.668 88.3953C122.459 87.9083 123.251 87.9083 123.738 88.2126L124.651 88.7604C124.103 88.4561 123.373 88.517 122.581 88.9431L107.669 97.5254C106.877 98.0123 106.086 98.8036 105.599 99.7166C105.051 100.63 104.747 101.664 104.747 102.638V119.803C104.747 120.777 105.051 121.385 105.599 121.751L104.686 121.203C104.138 120.899 103.834 120.229 103.834 119.255V102.09C103.773 101.117 104.138 100.082 104.686 99.1688Z",
    fill: "url(#paint8_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M102.19 97.7082C102.738 96.7952 103.469 95.943 104.26 95.5169L119.172 86.9346C119.964 86.4477 120.755 86.4477 121.242 86.752L122.155 87.2998C121.607 86.9955 120.877 87.0564 120.085 87.4824L105.173 96.0648C104.382 96.5517 103.59 97.343 103.103 98.256C102.556 99.169 102.251 100.204 102.251 101.178V118.342C102.251 119.316 102.556 119.925 103.103 120.29L102.19 119.742C101.642 119.438 101.338 118.768 101.338 117.794V100.569C101.277 99.7168 101.642 98.6212 102.19 97.7082Z",
    fill: "url(#paint9_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6339 96.2471C100.182 95.3341 100.912 94.482 101.703 94.0559L116.616 85.4736C117.407 84.9866 118.198 84.9866 118.685 85.291L119.598 85.8388C119.051 85.5344 118.32 85.5953 117.529 86.0214L102.616 94.6037C101.825 95.0906 101.034 95.8819 100.547 96.7949C99.9991 97.7079 99.6948 98.7427 99.6948 99.7166V116.942C99.6948 117.916 99.9991 118.525 100.547 118.89L99.6339 118.342C99.0861 118.038 98.7817 117.368 98.7817 116.394V99.1688C98.7817 98.2557 99.1469 97.221 99.6339 96.2471Z",
    fill: "url(#paint10_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1382 94.8472C97.6861 93.9342 98.4165 93.0821 99.2077 92.656L114.12 84.0737C114.912 83.5868 115.703 83.5259 116.19 83.8911L117.103 84.4389C116.555 84.1346 115.825 84.1954 115.033 84.6215L100.182 93.143C99.3903 93.6299 98.5991 94.4212 98.1121 95.3342C97.5643 96.2472 97.26 97.282 97.26 98.2558V115.481C97.26 116.455 97.5643 117.064 98.1121 117.429L97.1991 116.881C96.6513 116.577 96.347 115.907 96.347 114.934V97.708C96.2861 96.795 96.6513 95.7603 97.1382 94.8472Z",
    fill: "url(#paint11_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6427 93.3865C95.1905 92.4735 95.9209 91.6214 96.7122 91.1953L111.625 82.613C112.416 82.126 113.207 82.126 113.694 82.4304L114.607 82.9782C114.059 82.6738 113.329 82.7347 112.538 83.1608L97.6252 91.7431C96.8339 92.23 96.0426 93.0213 95.5557 93.9343C95.0079 94.8473 94.7035 95.8821 94.7035 96.856V114.081C94.7035 115.055 95.0079 115.664 95.5557 116.029L94.6427 115.481C94.0949 115.177 93.7905 114.508 93.7905 113.534V96.3082C93.7905 95.3343 94.0949 94.2995 94.6427 93.3865Z",
    fill: "url(#paint12_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1473 91.9255C92.6951 91.0125 93.4255 90.1603 94.2168 89.7342L109.129 81.1519C109.921 80.665 110.712 80.665 111.199 80.9693L112.112 81.5171C111.564 81.2128 110.834 81.2737 110.042 81.6997L95.1298 90.282C94.3385 90.769 93.5473 91.5603 93.0603 92.4733C92.5125 93.3863 92.2082 94.421 92.2082 95.3949V112.62C92.2082 113.594 92.5125 114.203 93.0603 114.568L92.1473 114.02C91.5995 113.716 91.2952 113.047 91.2952 112.073V94.908C91.2952 93.9341 91.5995 92.8385 92.1473 91.9255Z",
    fill: "url(#paint13_linear)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6515 90.4648C90.1993 89.5518 90.9297 88.6996 91.721 88.2735L106.634 79.6912C107.425 79.2043 108.216 79.2043 108.703 79.5086L109.616 80.0564C109.068 79.7521 108.338 79.8129 107.547 80.239L92.634 88.8213C91.8427 89.3083 91.0514 90.0996 90.5645 91.0126C90.0167 91.9256 89.7123 92.9603 89.7123 93.9342V111.16C89.7123 112.134 90.0167 112.742 90.5645 113.108L89.6515 112.56C89.1037 112.255 88.7993 111.586 88.7993 110.612V93.4473C88.7993 92.4734 89.1037 91.4387 89.6515 90.4648Z",
    fill: "url(#paint14_linear)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 99.3879C89.8 99.6879 91.1 103.288 88.4 104.388C87 103.588 86.6 99.9879 89.5 99.3879Z",
    fill: "#292929"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8 99.3879L89.5 99.9879C90.5 100.288 92.9 99.7879 94.3 98.3879C95.7 96.9879 96 99.6879 94.4 100.488C92.8 101.288 92.8 101.888 95.4 102.388C96.6 102.588 97.9 103.288 98.3 103.688C99.2 104.588 100.3 106.688 98.8 107.688C97.6 108.488 94.1 106.888 93 106.488C90 105.288 90.6 104.688 89 103.888C87.3 103.088 87 103.088 87 103.088L87.8 99.3879Z",
    fill: "#F6D3AF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0999 70.0879C72.1999 69.6879 69.7999 69.9879 68.1999 75.5879C66.7999 80.2879 67.8999 89.8879 68.7999 92.4879C70.8999 99.2879 79.2999 101.688 88.4999 104.288C87.2999 102.988 88.0999 99.9879 89.5999 99.2879C83.3999 96.5879 77.5999 92.6879 75.5999 90.5879C75.5999 88.2879 76.6999 79.3879 76.8999 76.3879C76.9999 72.6879 75.8999 70.4879 74.0999 70.0879Z",
    fill: "#59595B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.55,
    y1: 135,
    x2: 23.55,
    y2: 149.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.7081,
    y1: 145.303,
    x2: 17.7081,
    y2: 128.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.1404,
    y1: 58.8869,
    x2: 79.2582,
    y2: 58.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D7D9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#EDEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 173.942,
    y1: 146.348,
    x2: 207.255,
    y2: 146.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D7D9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#EDEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 223.936,
    y1: 34.2572,
    x2: 223.936,
    y2: 68.0932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 202.805,
    y1: 63.3197,
    x2: 202.805,
    y2: 78.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 110.952,
    y1: 42.585,
    x2: 150.786,
    y2: 42.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8095,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 94.8,
    y1: 86.3675,
    x2: 44.8709,
    y2: 110.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 114.228,
    y1: 115.067,
    x2: 104.93,
    y2: 101.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 111.732,
    y1: 113.607,
    x2: 102.434,
    y2: 100.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 109.179,
    y1: 112.194,
    x2: 99.8579,
    y2: 98.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 106.71,
    y1: 110.741,
    x2: 97.3944,
    y2: 97.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 104.187,
    y1: 109.334,
    x2: 94.8667,
    y2: 96.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 101.692,
    y1: 107.873,
    x2: 92.3713,
    y2: 94.6699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 99.1961,
    y1: 106.412,
    x2: 89.8755,
    y2: 93.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollectionPreview);
export default __webpack_public_path__ + "static/media/data_collection_preview.29b97ca2bbc0f9b3a2e06510023a6b1b.svg";
export { ForwardRef as ReactComponent };